import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuickReference = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_25096",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_25096)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.5094 16.2499H14.2465V13.3333H13.5094V16.2499ZM13.878 12.572C13.9784 12.5774 14.0649 12.5424 14.1375 12.467C14.2102 12.3917 14.2465 12.3039 14.2465 12.2035C14.2465 12.103 14.2089 12.0165 14.1336 11.9439C14.0583 11.8712 13.9731 11.8349 13.878 11.8349C13.7775 11.8349 13.691 11.8712 13.6184 11.9439C13.5457 12.0165 13.5094 12.103 13.5094 12.2035C13.5094 12.2986 13.5457 12.3838 13.6184 12.4591C13.691 12.5344 13.7775 12.572 13.878 12.572ZM4.1665 3.33325V8.48554V8.46138V16.6666V3.33325ZM6.0415 11.4583H8.93567C9.0565 11.2242 9.1922 11.003 9.34275 10.7947C9.49345 10.5864 9.65907 10.3909 9.83963 10.2083H6.0415V11.4583ZM6.0415 14.7916H8.34755C8.31657 14.5833 8.30109 14.3762 8.30109 14.1705C8.30109 13.965 8.31393 13.7553 8.33963 13.5416H6.0415V14.7916ZM4.42296 17.9166C4.00199 17.9166 3.64567 17.7708 3.354 17.4791C3.06234 17.1874 2.9165 16.8311 2.9165 16.4101V3.58971C2.9165 3.16874 3.06234 2.81242 3.354 2.52075C3.64567 2.22909 4.00199 2.08325 4.42296 2.08325H11.0415L15.4165 6.45825V8.68742C15.2114 8.62547 15.0059 8.5777 14.8003 8.54409C14.5946 8.51033 14.3833 8.49082 14.1665 8.48554V7.08325H10.4165V3.33325H4.42296C4.3588 3.33325 4.30005 3.35999 4.24671 3.41346C4.19324 3.46679 4.1665 3.52554 4.1665 3.58971V16.4101C4.1665 16.4743 4.19324 16.533 4.24671 16.5864C4.30005 16.6398 4.3588 16.6666 4.42296 16.6666H8.96775C9.08845 16.9059 9.22414 17.1297 9.37484 17.338C9.52553 17.5464 9.6938 17.7392 9.87963 17.9166H4.42296ZM13.878 10.2885C14.9187 10.2885 15.8038 10.6533 16.5334 11.383C17.2631 12.1126 17.628 12.9978 17.628 14.0385C17.628 15.079 17.2631 15.9642 16.5334 16.6939C15.8038 17.4235 14.9187 17.7883 13.878 17.7883C12.8374 17.7883 11.9523 17.4235 11.2225 16.6939C10.4928 15.9642 10.128 15.079 10.128 14.0385C10.128 12.9978 10.4928 12.1126 11.2225 11.383C11.9523 10.6533 12.8374 10.2885 13.878 10.2885Z",
			fill: "#2B4752"
		})
	})]
});
export default SvgQuickReference;
